var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.authors),function(author,i){return _c('v-col',{key:i,attrs:{"cols":"4"}},[_c('author-summary',{key:i,attrs:{"name":author.author_name,"source":author.source_id,"seen":author.last_posted,"author":author}})],1)}),(_vm.loading)?_c('v-col',{attrs:{"cols":"4"}},_vm._l((Array.from(
        Array(3 - (_vm.authors.length % 3)).keys()
      )),function(placeholder,i){return _c('span',{key:i},[_c('v-skeleton-loader',{attrs:{"type":"card","height":"124"}})],1)}),0):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }